import type { StorageAdapter } from './adapters';

export interface DocumentStore<T> {
  read(): Promise<T>;
  write(value: T): Promise<void>;
  patch(partial: Partial<T>): Promise<T>;
}

/** For singleton documents such as Settings, where a collection would be overkill. */
export function createDocumentStore<T extends object>(
  adapter: StorageAdapter,
  key: string,
  fallback: T,
): DocumentStore<T> {
  return {
    async read() {
      const stored = await adapter.read<T>(key);
      return { ...fallback, ...(stored ?? {}) };
    },
    async write(value) {
      await adapter.write(key, value);
    },
    async patch(partial) {
      const current = await this.read();
      const next = { ...current, ...partial };
      await adapter.write(key, next);
      return next;
    },
  };
}
